import { render, staticRenderFns } from "./SecurePassword.vue?vue&type=template&id=ca0b7152&"
import script from "./SecurePassword.vue?vue&type=script&lang=js&"
export * from "./SecurePassword.vue?vue&type=script&lang=js&"
import style0 from "./secure-password.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports